
// to show a list of habits in suggestion list


// array habits
// each element contains a id, habit = name of habit, url= an icon url for the respective habit

export const SuggestedHabit = [
                {
                    id:'1',
                    habit:'Read 1 page',
                    url:'https://cdn-icons-png.flaticon.com/512/4334/4334793.png'
                },
                {
                    id:'2',
                    habit:'Meditate 5 min',
                    url:'https://cdn-icons-png.flaticon.com/512/3663/3663335.png'
                },
                {
                    id:'3',
                    habit:'Running',
                    url:'https://cdn-icons-png.flaticon.com/512/5073/5073994.png'
                },
                {
                    id:'4',
                    habit:'Jogging',
                    url:'https://cdn-icons-png.flaticon.com/512/5147/5147006.png'
                },
                {
                    id:'5',
                    habit:'Excersice',
                    url:'https://www.freeiconspng.com/thumbs/exercise-icon/exercise-icon-1.png'
                },
                {
                    id:'6',
                    habit:'Wake up Early',
                    url:'https://cdn-icons-png.flaticon.com/512/760/760644.png'
                },
                {
                    id:'7',
                    habit:'Go to bed by 11',
                    url:'https://cdn-icons-png.flaticon.com/512/1422/1422923.png'
                },
                {
                    id:'8',
                    habit:'Walk the dog',
                    url:'https://cdn-icons-png.flaticon.com/512/4253/4253264.png'
                },
                {
                    id:'9',
                    habit:'Cleaning',
                    url:'https://cdn-icons-png.flaticon.com/512/995/995053.png'
                },
                {
                    id:'10',
                    habit:'Swimming',
                    url:'https://uxwing.com/wp-content/themes/uxwing/download/sport-and-awards/swimming-icon.png'
                },
                {
                    id:'11',
                    habit:'Write Diary',
                    url:'https://cdn-icons-png.flaticon.com/512/46/46395.png'
                },
                {
                    id:'12',
                    habit:'Water Plant',
                    url:'https://cdn-icons-png.flaticon.com/512/4147/4147953.png'
                },
                {
                    id:'13',
                    habit:'Do 10 PushUps',
                    url:'https://cdn-icons-png.flaticon.com/512/2548/2548530.png'
                }
            ]